'use client'

import LinkWithArrow            from '@/components/buttons/LinkWithArrow'
import useProjectCardAnimation  from '@/components/projects/ProjectCard.animation'
import {useT}                   from '@/i18n/useT'
import cn                       from 'classnames'
import Image                    from 'next/image'
import Link                     from 'next/link'
import {useCallback}            from 'react'

import styles from './ProjectCard.module.sass'

const ProjectCard = ({
	project,
	index,
	isImagePriority,
	...props
}) => {
	const t                    = useT()
	const {cardRef, isVisible} = useProjectCardAnimation()

	const handleMouseEnter = useCallback(() => {
		document.documentElement.style.setProperty('--selected-project-hover-color', project.hover_color)
		document.documentElement.style.setProperty('--selected-project-hover-background-color', project.hover_background_color)
	}, [project.hover_color])
	const handleMouseLeave = useCallback(() => {
		document.documentElement.style.removeProperty('--selected-project-hover-color')
		document.documentElement.style.removeProperty('--selected-project-hover-background-color')
	}, [project.hover_color])

	return (<div
		className={cn(styles['project-card'], 'project-card', isVisible && styles['project-card--visible'])}
		style={{
			'--project-card-color': project.title_color,
		}}
		data-type={'project-card'}
		data-arrow-hover
		ref={cardRef}
		{...props}
	>
		<Link
			className={styles['project-card__content']}
			href={project.link ?? ''}
			target={'_blank'}
			data-cursor-eye
			onMouseEnter={handleMouseEnter}
			onMouseLeave={handleMouseLeave}
			onFocus={(e) => {
				if (e.currentTarget.matches(':focus-visible')) {
					handleMouseEnter()
				}
			}}
			onBlur={handleMouseLeave}
		>
			<div
				className={styles['project-card__background']}
				style={{backgroundColor: project.background_color ?? ''}}
			>
				{project.background_image && <Image
					src={project.background_image.url}
					alt={''}
					fill={true}
					sizes={'(max-width: 768px) 100vw, 50vw'}
					quality={75}
				/>}
			</div>

			<div className={styles['project-card__image__container']}>
				<span className={styles['project-card__title']}>
					<span className={styles['project-card__title-inner']}>{project.title}</span>
				</span>

				<div className={styles['project-card__image-mask']}>
					<Image
						src={project.image.url}
						alt={''}
						fill={true}
						sizes={'(max-width: 768px) 80vw, 40vw'}
						quality={75}
						className={styles['project-card__image']}
						priority={isImagePriority}
						fetchPriority={isImagePriority ? 'high' : 'auto'}
					/>
				</div>
			</div>
		</Link>

		<LinkWithArrow
			arrowType={'diagonal'}
			arrowVariant={'dotted'}
			href={project.link ?? ''}
			className={styles['project-card__cta']}
			data-cursor-pointer

			onMouseEnter={handleMouseEnter}
			onMouseLeave={handleMouseLeave}

			onFocus={(e) => {
				if (e.currentTarget.matches(':focus-visible')) {
					handleMouseEnter()
				}
			}}
			onBlur={handleMouseLeave}
		>{t('discover_website')}</LinkWithArrow>
	</div>)
}
export default ProjectCard
